$(document).on('click', '.js-search-show', function H(e) {
    $('.js-search-more').addClass('active');
});

$(document).mousedown(function(event) {
    let targetElement = event.target;
    let sidebarElement = $('.js-search-more')[0]; // Assuming your sidebar has an id of 'sidebar'

    if (!$(targetElement).closest('.js-search-more').length && !$(targetElement).is('#sidebar')) {
        $('.js-search-more').removeClass('active');
        $('.js-search-wrap').removeClass('active');
    }
});

$(document).on('click', '.js-search-mobile-show', function H(e) {
    $('.js-search-more').addClass('active');
    $('.js-search-wrap').addClass('active');
});

$(document).on('click', '.js-header-btn', function H(e) {
    $('.main-nav').toggleClass('active');
    $('body').toggleClass('body-overflow');
});
